// extracted by mini-css-extract-plugin
export default {"contents":"ZI-z","sectionHeading":"_I-z"};